import request from '@/utils/request'
/**
 * 获取课程系列课
 * {String} no 课程编号
 * @return {AxiosPromise}
 */
export function getBookDetailApi (data) {
    return request({
        url: 'product/store/detail',
        params: data,
    })
}
